<section class="chips-section" *ngIf="specialities.length">
  <h3 class="chips-section__label">
    {{ "UX_TEXT.DEMANDE.CHIPS.TITLE" | translate }}
    <span class="chips-section__label-opt">({{ "UX_TEXT.DEMANDE.COMMON.OPTIONAL" | translate }})</span>
  </h3>
  <div class="chips-scroll">
    <button
      type="button"
      class="chip"
      *ngFor="let speciality of specialities"
      [ngClass]="{ 'chip--active': selectedSpeciality === speciality }"
      (click)="specialitySelected.emit(speciality)"
    >
      {{ speciality.nom }}
    </button>
  </div>
</section>
